import React from "react";
import { useWhitelabel } from "../../contexts/WhitelabelContext";
import { Form } from "react-bootstrap";

const NewZoneOfferItem = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  zones,
}) => {
  const { backgroundColor, fontColor } = useWhitelabel();

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Service</Form.Label>
        <Form.Select
          name="serviceId"
          value={values.serviceId}
          onChange={(e) => {
            const selectedIndex = e.target.selectedIndex;
            const selectedOption = e.target.options[selectedIndex];
            const selectedLabel = selectedOption.text;

            setFieldValue("serviceId", e.target.value);
            setFieldValue("name", selectedLabel);
            setFieldValue("description", selectedLabel);
          }}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.serviceId && errors.serviceId)}
        >
          <option value="">Select Zone</option>
          {zones.map((zone) => {
            return <option value={zone.id}>{zone.name}</option>;
          })}
        </Form.Select>
        {!!touched.serviceId && (
          <Form.Control.Feedback type="invalid">
            {errors.serviceId}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Price</Form.Label>
        <Form.Control
          type="text"
          name="price"
          value={values.price}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.price && errors.price)}
        />
        {!!touched.price && (
          <Form.Control.Feedback type="invalid">
            {errors.price}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>VAT(%)</Form.Label>
        <Form.Control
          type="text"
          value={values.vat}
          name="vat"
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.vat && errors.vat)}
        />
        {!!touched.vat && (
          <Form.Control.Feedback type="invalid">
            {errors.vat}
          </Form.Control.Feedback>
        )}
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Unit Type</Form.Label>
        <Form.Select
          name="unitType"
          value={values.unitType}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={Boolean(touched.unitType && errors.unitType)}
        >
          <option value="">Select unit type</option>
          <option value="byte">Byte</option>
          <option value="kb">KB</option>
          <option value="mb">MB</option>
          <option value="gb">GB</option>
        </Form.Select>
      </Form.Group>
    </>
  );
};

export default NewZoneOfferItem;
